import styled from 'styled-components';
import { Button } from 'components/atoms/button';

export const Trigger = styled(Button).attrs({
  size: 'small',
  type: 'text',
})`
  justify-content: space-between;
  color: var(--blue-60);

  svg {
    margin-right: var(--spacing-06);
    margin-left: var(--spacing-03);
    color: var(--gray-40);
  }
`;
